import { render, staticRenderFns } from "./view-worker.vue?vue&type=template&id=2c1f77dd&"
import script from "./view-worker.vue?vue&type=script&lang=js&"
export * from "./view-worker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports